import { ORG_ROLES } from './constants';
import { isQualiaOrganization } from './global';

export const NO_REQUESTED_BY_USERS_MESSAGE = 'This organization has no enabled users.';

export const REQUESTED_BY_REQUIRED_MESSAGE = 'Select who requested this order.';

const organizationIdOf = organization => organization?._id || organization || '';

export const requestedByApplies = (organization, isIndividual) => {
  if (isIndividual || !organization) return false;
  if (organization.isQualia === true) return false;
  return !isQualiaOrganization(organization);
};

export const eligibleRequestedByUsers = (users, organization) => {
  const organizationId = String(organizationIdOf(organization));
  if (!organizationId) return [];

  return (users || []).filter(user => {
    if (!user?.isEnabled) return false;
    if (!ORG_ROLES.includes(user.role)) return false;
    return String(organizationIdOf(user.organization)) === organizationId;
  });
};

export const requestedByLabel = user => `${user?.name || ''} (${user?.email || ''})`.trim();

export const savedRequestedById = requestedBy => {
  if (!requestedBy) return '';
  if (typeof requestedBy === 'string') return requestedBy;
  return requestedBy._id || '';
};

export const nextRequestedById = ({ applies, eligible, requestedBy }) => {
  if (!applies) return '';
  if (eligible.length === 1) return eligible[0]._id;
  if (requestedBy && eligible.some(user => user._id === requestedBy)) return requestedBy;
  return '';
};

export const requestedByError = ({ organization, isIndividual, users, requestedBy }) => {
  if (!requestedByApplies(organization, isIndividual)) return '';
  const eligible = eligibleRequestedByUsers(users, organization);
  if (!eligible.length) return NO_REQUESTED_BY_USERS_MESSAGE;
  if (!eligible.some(user => user._id === requestedBy)) return REQUESTED_BY_REQUIRED_MESSAGE;
  return '';
};
